import React from "react";
import { Box, Grid, IconButton, styled, Typography } from "@mui/material";

import userLogo from "../../resources/images/png/header/icon-login.png";
import logo from "../../resources/images/svg/inexplore-logo-white.svg";
import {
  getLoginRedirectURL,
  useIsLoggedIn,
  useIsSubscribed,
} from "../../hooks/auth";
import UserAvatar from "./UserAvatar";
import Universe from "./Universe";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import SmallHeader from "./SmallHeader";
import RainbowDivider from "../misc/RainbowDivider";
import InexButton from "../InexButton";
import { PersonRounded } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router";

const Container = styled(Grid)(({ theme }) => {
  return {
    width: "100%",
    minHeight: "82px",
    top: 0,
    right: 0,
    left: 0,
    position: "sticky",
    display: "flex",
    zIndex: theme.zIndex.appBar,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    background: "#0D0034",
  };
});
const Wrapper = styled(Grid)(({ theme }) => {
  return {
    margin: "0",
    marginTop: theme.spacing(2),
    boxSizing: "border-box",
    display: "flex",
    width: "100%",
    padding: "0 20px",
    maxWidth: "1500px",
    height: "100%",
    minHeight: "100%",
    alignItems: "center",
    justifyContent: "space-between",
  };
});

export const BackgroundBox = styled(Box)((theme) => {
  return {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "linear-gradient(90deg, #162941 0%, #8F6C9F 100%)",
    overflow: "hidden",
  };
});

export const GradientTypo = styled(Typography)(({
  theme,
  disabled = false,
  background,
}) => {
  return {
    fontWeight: 700,
    background:
      disabled === false
        ? background
          ? background
          : "linear-gradient(90deg, #EE7992 0%, #F1AE65 50.51%, #F4C54D 100%)"
        : theme.palette.grey["400"],
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    overflow: "hidden",
    fontFamily: "Branding Bold",
    display: "block",
    "&:first-letter": {
      textTransform: "capitalize !important",
    },
  };
});

export const Subtitle = styled(Typography)((theme) => {
  return {
    textAlign: "left",
    color: "white",
    fontFamily: "Branding SemiBold",
    fontWeight: 600,
    fontSize: 20,
    maxWidth: 700,
  };
});

export const UserInitialsContainer = styled(Box)(({ theme }) => {
  return {
    backgroundColor: "rgba(36,38,56,0.53)",
    borderRadius: "50%",
    height: 42,
    width: 42,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: theme.transitions.create(["box-shadow"]),
    "&:hover": {
      boxShadow: "0 0 15px 0 rgb(36 38 56 / 53%)",
    },
  };
});

export const Banner = styled(Box)(({ theme }) => {
  return {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "37px",
    backgroundColor: "#F1C555",
  };
});

const Header = () => {
  const isLoggedIn = useIsLoggedIn();

  const redirectUrl = getLoginRedirectURL();

  const { width } = useWindowDimensions();

  const isSubscribed = useIsSubscribed();
  const navigate = useNavigate();

  const [infoPrive, setInfoPrive] = React.useState({ title: "Le projet Praticiens", href: "/public" });
  let location = useLocation();

  React.useEffect(() => {
    // Google Analytics
    if (location.pathname == '/public') {
      setInfoPrive({ title: "Mon espace Praticiens", href: "/" })
    }
  }, [location]);

  if (width < 1207) {
    return <SmallHeader />;
  }

  return (
    <Container>
      <Wrapper container justifyContent="space-between" margin={2}>
        <Grid
          item
          alignItems={"center"}
          display={"flex"}
          sx={{
            cursor: 'pointer'
          }}
        >
          <img
            src={logo}
            className=""
            alt="logo"
            onClick={() => navigate("/")}
          />
        </Grid>
        <Grid
          item
          container
          justifyContent={"flex-end"}
          alignItems={"center"}
          display={"flex"}
          columnSpacing={3}
          flexWrap={"nowrap"}
          ml={0.5}
        >
          {isSubscribed && (
            <Grid item>
              <a href={infoPrive.href} target="_blank" rel="noopener noreferrer" >
                <InexButton
                  text={infoPrive.title}
                  variant={"text"}
                  textWithGradient={false}
                  sx={{
                    zIndex: 1,
                    height: "45px",
                    background: (theme) => theme.palette.primary.main,
                    border: "none",
                    color: "white",
                    "&:hover": {
                      backgroundColor: "white",
                      "& > p": {
                        color: (theme) => theme.palette.primary.main,
                      },
                      "& > svg": {
                        fill: (theme) => theme.palette.primary.main,
                      },
                    },
                  }}
                />
              </a>
            </Grid>
          )}
          <Grid item>
            <Universe />
          </Grid>
          <Grid item>
            {isLoggedIn ? (
              <UserAvatar />
            ) : (
              <a href={redirectUrl} style={{ color: "white", fontWeight: 700 }}>
                <IconButton sx={{ width: 45, height: 45 }} size={"medium"}>
                  <img src={userLogo} alt={"user-logo"} />
                </IconButton>
                {'Se connecter'}
              </a>
            )}
          </Grid>
        </Grid>
      </Wrapper>
      <RainbowDivider />
    </Container>
  );
};

export default Header;
